import { getActiveMcaRequest } from "../components/mca/mcaApprovalLabels";

export const isFormReadOnly = ({
  formMode,
  isMcaLocked = false,
  effectiveAccessRight,
  pageListReadOnly = false,
} = {}) => {
  if (pageListReadOnly) return true;
  if (effectiveAccessRight === 1) return true;
  if (formMode === "show") return true;
  if (isMcaLocked) return true;
  return false;
};

export const isFieldDisplayReadOnly = ({
  formMode,
  isMcaLocked = false,
  effectiveAccessRight,
  pageListReadOnly = false,
  fieldProps = {},
} = {}) => {
  const showLocked = formMode === "show" && !fieldProps.editableInShowMode;
  const mcaLocked = isMcaLocked && !fieldProps.editableDuringMcaApproval;
  const pageLocked = effectiveAccessRight === 1 || pageListReadOnly;
  return Boolean(showLocked || mcaLocked || pageLocked);
};

const toPageAccessRight = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const shouldHideFormActionList = (form, pageAccessRight) => {
  const access = toPageAccessRight(pageAccessRight);
  if (access === 0) return true;
  // A Read Only page still shows actions the role marked Accessible.
  // The form is locked in that case, so do not treat that lock as a hide.
  if (access !== 1 && Boolean(form?.isReadOnly?.())) return true;
  if (getActiveMcaRequest(form?.values)) return true;
  return false;
};

export const isWidgetReadOnly = ({
  disabled = false,
  readOnly = false,
  readonly = false,
  form,
} = {}) => Boolean(disabled || readOnly || readonly || form?.isReadOnly?.());
